import config from 'config';

const consts = {
    zoomAuthorizationUrl: `https://zoom.us/oauth/authorize?response_type=code&client_id=${config.ZOOM_CLIENT_ID}&redirect_uri=${config.UI_URL}/zoom-setup`
};

export default consts;
